import {
  Component, Input, OnInit, Output, EventEmitter
} from '@angular/core';
import * as _ from 'lodash';

import { Config } from 'shared/config/env.config';


@Component({
  moduleId: module.id,
  selector: 'app-plan',
  templateUrl: 'plan.component.html',
  styleUrls: ['plan.component.scss'],
})
export class PlanComponent {
  helpLink: string = Config.DEFAULT_SUPPORT_URL;

  @Input() plan: any;
  @Input() isContact: boolean = false;
  @Input() isCustom: boolean = false;
  @Input() isSuggestedPlan: boolean = false;

  @Output() selected = new EventEmitter<any>();
  @Output() unselected = new EventEmitter<any>();

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isCurrentPlan(): boolean {
    if (!this.plan) { return false; }
    return this.plan.current_subscription;
  }

  get isSelected(): boolean {
    if (!this.plan) { return false; }
    return this.plan.is_selected;
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

   onUpgradeClick() {
     this.selected.emit(this.plan);
   }

   onConfirmClick() {
     this.unselected.emit(this.plan);
   }

   onContactClick() {
     (window.open(this.helpLink, '_blank')).focus();
   }
}
